module.exports = __webpack_public_path__ + "img/lock.baf9635c.png";